import React, { ChangeEvent, useState } from 'react'
import { RadioButtonProps } from './RadioButton.props'
import {
  RadioButtonLabel,
  RadioButtonInput,
  RadioButtonMark,
} from './RadioButton.styled'

const RadioButton = ({
  key,
  text,
  name,
  value,
  checked,
  weight = '400',
  size = '14px',
  onChange,
  disabled,
}: RadioButtonProps) => {

  const [checkedValue, setCheckedValue] = useState<boolean | undefined>(checked);

  const textLength = text.length;

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    setCheckedValue(!checkedValue);
    onChange && onChange(evt.target.checked ? evt.target.value : null);
  }

  return (
      <RadioButtonLabel weight={weight} size={size} disabled={disabled ? disabled : false}>
        {text.map((t, index) => index === textLength - 1 ? t : t + "\n")}
          <RadioButtonInput
            type="radio"
            name={name}
            checked={checkedValue}
            value={value}
            onChange={handleChange}
            disabled={disabled}
            key={`radio-${key}`}
          />
          <RadioButtonMark key={`mark-${key}`} size={size} disabled={disabled ? disabled : false} />
      </RadioButtonLabel>
  )
}

export default RadioButton
